import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getFlatData } from './createFlatData';
import { MultiSelector } from './models/selector/multi-selector-model';

@Component({
  selector: 'angular-custom-selector',
  templateUrl: 'angular-custom-selector.component.html',
  styles: []
})
export class AngularCustomSelectorComponent implements OnInit {
  @Input() type: string = "single";
  @Input() labelText: string;
  @Input() selectedId: number = null;
  @Input() selectedName: string = 'Select';
  @Input() public enableAllNodes: boolean = false;
  @Input() disabled: boolean = false;
  @Input() public data: Array<any>;
  @Input() hoverText: string;
  @Input() displayName: string;
  @Input() searchKey: string;
  @Output() public onChange : EventEmitter<any> = new EventEmitter<any>();
  @Output() public onFetchedData : EventEmitter<any> = new EventEmitter<any>();
  public dataHierarchy: MultiSelector = { data:[], flatData:[] };

  constructor() { }

  ngOnInit(): void {
    this.dataHierarchy.data = this.data;
    getFlatData(this.data,this.dataHierarchy.flatData);
  }

  onFetched(data: MultiSelector) {
    this.onFetchedData.emit(data);
    this.dataHierarchy = data;
  }

  public updateLocationState(dataItem:any){
    this.onChange.emit(dataItem);
  }

}
